<template>
  <v-form ref="form" v-model="validacion" lazy-validation>
    <v-layout v-if="tipeView != 'aprobacion'">
      <v-flex xs12 md6>
        <v-text-field
          v-model="rut"
          label="Rut"
          counter="10"
          maxlength="10"
          :error-messages="rutErrors"
          :box="isDisabledRut"
          :readonly="isDisabledRut"
          @input="dvRut()"
          @focusout="checkRut"
          @blur="tipeView == 'crear' ? $v.rut.$touch() : null"
        ></v-text-field>
        <v-text-field
          v-model="nombre"
          label="Nombre"
          :error-messages="nombreErrors"
          :box="isDisabled"
          :readonly="isDisabled"
          @input="$v.nombre.$touch()"
          @blur="tipeView == 'crear' ? $v.nombre.$touch() : null"
        ></v-text-field>
        <v-text-field
          v-model="apellido1"
          label="Primer Apellido"
          :error-messages="apellidoErrors"
          :box="isDisabled"
          :readonly="isDisabled"
          @input="$v.apellido1.$touch()"
          @blur="tipeView == 'crear' ? $v.apellido1.$touch() : null"
        ></v-text-field>
        <v-text-field
          v-model="apellido2"
          label="Segundo Apellido"
          :error-messages="apellidoErrors"
          :box="isDisabled"
          :readonly="isDisabled"
          @input="$v.apellido2.$touch()"
          @blur="tipeView == 'crear' ? $v.apellido2.$touch() : null"
        ></v-text-field>
        <v-select
          v-model="profesionValue"
          :items="profesionSelect"
          :box="isDisabledselect"
          item-text="nombre"
          item-value="code"
          :readonly="isDisabledselect"
          label="Profesión"
        ></v-select>
        <v-text-field
          v-model="fono"
          :error-messages="fonoErrors"
          label="Teléfono"
          :box="isDisabled"
          :readonly="isDisabled"
          @input="$v.fono.$touch()"
          @blur="tipeView == 'crear' ? $v.fono.$touch() : null"
        ></v-text-field>
        <v-text-field
          v-model="email"
          :error-messages="emailErrors"
          label="E-mail"
          :box="isDisabledSel"
          :readonly="isDisabledSel"
          @input="$v.email.$touch()"
          @blur="tipeView == 'crear' ? $v.email.$touch() : null"
        ></v-text-field>
      </v-flex>
      <v-flex xs12 md1></v-flex>
      <v-flex xs12 md6>
        <v-select
          v-model="tipo_capValue"
          :items="tipo_capSelect"
          item-text="nombre"
          item-value="code"
          :error-messages="tipoCapacitacionErrors"
          label="Tipo de capacitación"
          :box="isDisabledselect"
          :readonly="isDisabledselect"
          @input="$v.tipo_capValue.$touch()"
        ></v-select>
        <v-select
          v-if="tipeView == 'consulta'"
          v-model="rc_inhabilitadoValue"
          :items="rc_inhabilitadoSelect"
          label="RC-Inhabilidad"
          :box="isDisabledselect"
          :readonly="isDisabledselect"
          data-vv-name="listaRc"
        ></v-select>
        <v-select
          v-if="tipeView == 'consulta' || tipeView == 'modifica'"
          v-model="aptoValue"
          :items="aptoSelect"
          :box="isDisabledAgencia"
          :readonly="isDisabledAgencia"
          label="Apto Capacitacion"
        ></v-select>
        <v-text-field
          v-if="tipeView == 'consulta'"
          v-model="aptoDs"
          label="Estado Capacitación DS"
          :box="isDisabled"
          :readonly="isDisabled"
        ></v-text-field>
        <v-text-field
          v-if="tipeView == 'consulta'"
          v-model="aptoConocimientos"
          label="Estado Capacitación Conocimientos"
          :box="isDisabled"
          :readonly="isDisabled"
        ></v-text-field>
        <v-text-field
          v-if="tipeView == 'consulta'"
          v-model="aptoCompetencias"
          label="Estado Capacitación Competencias"
          :box="isDisabled"
          :readonly="isDisabled"
        ></v-text-field>
        <v-select
          v-if="tipeView == 'consulta'"
          v-model="estadoValue"
          :items="estadoSelect"
          :box="isDisabledselect"
          :readonly="isDisabledselect"
          label="Estado Final del Relator"
        ></v-select>
      </v-flex>
    </v-layout>
    <v-layout>
      <v-flex xs12 v-if="tipeView == 'crear' || tipeView == 'modifica'">
        <v-toolbar-title class="indigo--text"
          >Adjuntar Curriculum</v-toolbar-title
        >
        <data-adjunto-cv
          :tipeView="tipeView"
          :tipeArchive="tipeArchive"
        ></data-adjunto-cv>
      </v-flex>
      <v-flex xs12 v-if="tipeView == 'consulta'" class="text-xs-center">
        <v-btn
          v-if="this.documento.filenameCv != null"
          icon
          @click="downloadCv(documento.id, documento.filenameCv)"
        >
          <v-icon>cloud_download</v-icon>&nbsp;Descargar CV
        </v-btn>
      </v-flex>
    </v-layout>
    <v-layout v-if="tipeView == 'aprobacion'">
      <v-flex xs12 md6>
        <v-text-field
          v-if="documento.capacitacion != 'Capacitación Regular'"
          v-model="aptoDs"
          label="Estado Capacitación DS"
          :box="isDisabled"
          :readonly="isDisabled"
        ></v-text-field>
        <v-text-field
          v-model="aptoConocimientos"
          label="Estado Capacitación Conocimientos"
          :box="isDisabled"
          :readonly="isDisabled"
        ></v-text-field>
        <v-text-field
          v-model="aptoCompetencias"
          label="Estado Capacitación Competencias"
          :box="isDisabled"
          :readonly="isDisabled"
        ></v-text-field>
      </v-flex>
      <v-flex xs12 md1></v-flex>
      <v-flex xs12 md6>
        <v-select
          v-if="documento.capacitacion != 'Capacitación Regular'"
          v-model="tipoCapDsValue"
          :items="tipoCapDsSelect"
          label="Gestión Capacitación DS"
        ></v-select>
        <v-select
          v-model="tipoCapConocimientosValue"
          :items="tipoCapConocimientosSelect"
          label="Gestión Capacitación Conocimientos"
        ></v-select>
        <v-select
          v-model="tipoCapCompetenciasValue"
          :items="tipoCapCompetenciasSelect"
          label="Gestión Capacitación Competencias"
        ></v-select>
      </v-flex>
    </v-layout>
    <v-card-actions class="pb-3">
      <v-btn
        v-if="tipeView == 'consulta' ? false : true"
        color="primary"
        dark
        :loading="loading"
        class="mb-2"
        @click="save()"
      >
        Guardar
        <v-icon right dark>save</v-icon>
      </v-btn>
    </v-card-actions>
  </v-form>
</template>

<script>
import { validationMixin } from "vuelidate";
import { required, maxLength, email } from "vuelidate/lib/validators";
import { misMixins } from "@/mixins/myMixing.js";
import axios from "axios";
import { error } from "util";
import DataAdjuntoCv from "@/components/AdjuntoData.vue";
export default {
  name: "relator-data",
  components: {
    DataAdjuntoCv,
  },
  mixins: [misMixins, validationMixin],
  props: {
    tipeView: "",
    id: "",
  },
  data() {
    return {
      loading: false,
      menu1: false,
      fechaNacimiento: "",
      tipoVisitaValue: "",
      allowSpaces: false,
      codigo: "",
      contratoId: "",
      descripcion: "",
      user: "",
      username: "",
      observacion: "",
      filenameValue: "",
      nombre: "",
      apellido1: "",
      apellido2: "",
      rut: "",
      documento: "",
      idRelatores: "",
      capacitacionSelect: [],
      rc_inhabilitadoSelect: [],
      rc_inhabilitadoValue: "",
      profesionValue: "",
      profesionSelect: [],
      capacitacionValue: "",
      aptoSelect: [],
      aptoValue: "",
      estadoSelect: [],
      estadoValue: "",
      validacion: "",
      dv: "",
      fono: "",
      email: "",
      direccion: "",
      cargoValue: "",
      cargoSelect: [],
      tipo_capValue: "",
      tipo_capSelect: [],
      aptoDs: "",
      aptoConocimientos: "",
      aptoCompetencias: "",
      tipeArchive: "",
      tipoCapDsValue: "",
      tipoCapDsSelect: [],
      tipoCapConocimientosValue: "",
      tipoCapConocimientosSelect: [],
      tipoCapCompetenciasValue: "",
      tipoCapCompetenciasSelect: [],
      tipeArchive: "",
    };
  },

  validations: {
    nombre: { required },
    apellido1: { required },
    apellido2: { required },
    rut: { required },
    email: { required, email },
    fono: { required },
    tipo_capValue: { required },
    fechaNacimiento: { required },
  },

  created() {
    this.tipeArchive = ".pdf,.doc,.docx";
    this.user = this.$store.getters.userLogged.tipo;
    if (this.tipeView === undefined) {
      this.tipeView = this.$route.params.tipeView;
    }
    if (this.tipeView == "consulta" || this.tipeView == "aprobacion") {
      this.loadData();
    }
    if (this.tipeView == "crear") {
      this.loadProfesiones();
      this.loadTipoCapacitaciones();
    }
    if (this.tipeView == "modifica") {
      this.loadData();
    }
  },
  mounted() {
    this.contratoId = this.$store.getters.contratoStored;
    this.idUsuario = this.$store.getters.userLogged.id;
  },
  computed: {
    rutErrors() {
      const errors = [];
      if (!this.$v.rut.$dirty) return errors;
      !this.$v.rut.required && errors.push("Rut es obligatorio.");
      return errors;
    },
    nombreErrors() {
      const errors = [];
      if (!this.$v.nombre.$dirty) return errors;
      !this.$v.nombre.required && errors.push("Nombre es obligatorio.");
      return errors;
    },
    apellidoErrors() {
      const errors = [];
      if (!this.$v.apellido1.$dirty || !this.$v.apellido2.$dirty) return errors;
      !this.$v.apellido1.required &&
        errors.push("Apellido Paterno es obligatorio.");
      !this.$v.apellido2.required &&
        errors.push("Apellido Materno es obligatorio.");
      return errors;
    },
    fonoErrors() {
      const errors = [];
      if (!this.$v.fono.$dirty) return errors;
      !this.$v.fono.required && errors.push("Teléfono es requerido.");
      return errors;
    },

    tipoCapacitacionErrors() {
      const errors = [];
      if (!this.$v.tipo_capValue.$dirty) return errors;
      !this.$v.tipo_capValue.required &&
        errors.push("Tipo de capacitación es requerida");
      return errors;
    },

    emailErrors() {
      const errors = [];
      if (!this.$v.email.$dirty) return errors;
      !this.$v.email.email &&
        errors.push("Debe ser una dirección de E-Mail válida");
      !this.$v.email.required && errors.push("E-mail is requerido");
      if (this.exist) {
        errors.push("E-mail ya existe");
      }
      return errors;
    },
    selectErrors() {
      const errors = [];
      if (!this.$v.tipo_capValue.$dirty) return errors;
      !this.$v.tipo_capValue.required && errors.push("Item is required");
      return errors;
    },

    isDisabled() {
      if (
        this.tipeView == "consulta" ||
        this.tipeView == "aprobacion" ||
        this.tipeView == "modifica"
      ) {
        return true;
      }
    },
    isDisabledSel() {
      if (this.tipeView == "modifica" || this.tipeView == "consulta") {
        return true;
      }
    },
    isDisabledRut() {
      if (this.tipeView == "modifica" || this.tipeView == "consulta") {
        return true;
      }
    },
    isDisabledselect() {
      if (this.tipeView == "consulta" || this.user == "AGENCIA") {
        return true;
      }
    },
    isDisabledAgencia() {
      if (this.tipeView == "consulta") {
        return true;
      }
    },
  },
  methods: {
    dvRut() {
      let f = this.formateaRut(this.rut);
      if (f == undefined) {
        this.rut = this.rut;
      } else {
        this.rut = f;
      }
    },
    checkRut() {
      let v = this.validaRut(this.rut);

      if (v === false) {
        return console.log("false");
      } else {
        //esto es para hacer algun tipo de validacion
        this.dv = obtenerDv(this.rut);
        return console.log("verdadero");
      }
    },
    submit() {
      this.$v.$touch();
    },
    async loadData() {
      this.documento = await this.loadRelatores();
      this.nombre = this.documento.nombre;
      this.apellido1 = this.documento.apellido1;
      this.apellido2 = this.documento.apellido2;
      this.dv = this.documento.dv;
      this.rut = this.documento.rut + "-" + this.dv;
      this.fono = this.documento.telefono;
      this.email = this.documento.email;
      this.profesionValue = this.documento.profesion;
      this.tipo_capValue = this.documento.tipoCapacitacion;

      this.loadRcInhabilitado();
      this.loadAptoSelect();
      this.loadTipoCapacitaciones();
      this.loadProfesiones();
      this.loadAptoDs();
      this.loadAptoCompetencias();
      this.loadAptoConocimientos();
      this.loadEstado();
    },
    loadAptoDs() {
      let aptoDS = this.documento.aptoDs;
      if (aptoDS == 0) {
        this.aptoDs = "En Proceso";
      } else if (aptoDS == 1) {
        this.aptoDs = "Aprobado";
      } else if (aptoDS == 2) {
        this.aptoDs = "Reprobado";
      }
      if (this.tipeView == "aprobacion") {
        this.tipoCapDsValue = aptoDS;
        this.tipoCapDsSelect = ["Aprobado", "Reprobado"];
      }
    },
    loadAptoConocimientos() {
      let aptoCon = this.documento.aptoConocimientos;
      if (aptoCon == 0) {
        this.aptoConocimientos = "En Proceso";
      } else if (aptoCon == 1) {
        this.aptoConocimientos = "Aprobado";
      } else if (aptoCon == 2) {
        this.aptoConocimientos = "Reprobado";
      }
      if (this.tipeView == "aprobacion") {
        this.tipoCapConocimientosValue = aptoCon;
        this.tipoCapConocimientosSelect = ["Aprobado", "Reprobado"];
      }
    },
    loadAptoCompetencias() {
      let aptoCom = this.documento.aptoCompetencias;
      if (aptoCom == 0) {
        this.aptoCompetencias = "En Proceso";
      } else if (aptoCom == 1) {
        this.aptoCompetencias = "Aprobado";
      } else if (aptoCom == 2) {
        this.aptoCompetencias = "Reprobado";
      }
      if (this.tipeView == "aprobacion") {
        this.tipoCapCompetenciasValue = aptoCom;
        this.tipoCapCompetenciasSelect = ["Aprobado", "Reprobado"];
      }
    },
    loadRcInhabilitado() {
      let rc_inhabilitado = this.documento.rcInhabilitado;
      let rc_asignar;
      if (rc_inhabilitado == 0) {
        rc_asignar = "En Proceso";
      } else if (rc_inhabilitado == 1) {
        rc_asignar = "Si";
      } else if (rc_inhabilitado == 2) {
        rc_asignar = "No";
      }
      if (this.tipeView == "consulta") {
        this.rc_inhabilitadoValue = rc_asignar;
        this.rc_inhabilitadoSelect = [this.rc_inhabilitadoValue];
      } else if (this.tipeView == "modifica") {
        this.rc_inhabilitadoValue = rc_asignar;
        this.rc_inhabilitadoSelect = ["Si", "No", "En Proceso"];
      }
    },
    loadAptoSelect() {
      let cap_apto = this.documento.aptoAgencia;
      let apto_asignar;
      if (cap_apto == 0) {
        apto_asignar = "En Proceso";
      } else if (cap_apto == 1) {
        apto_asignar = "Si";
      } else if (cap_apto == 2) {
        apto_asignar = "No";
      }
      if (this.tipeView == "consulta") {
        this.aptoValue = apto_asignar;
        this.aptoSelect = [this.aptoValue];
      } else if (this.tipeView == "modifica") {
        this.aptoValue = apto_asignar;
        this.aptoSelect = ["Si", "No", "En Proceso"];
      }
    },
    loadEstado() {
      let estado = this.documento.estado;
      let estado_asignar;
      if (estado == 0) {
        estado_asignar = "En Proceso";
      } else if (estado == 1) {
        estado_asignar = "Aprobado";
      } else if (estado == 2) {
        estado_asignar = "Rechazado";
      }
      if (this.tipeView == "consulta") {
        this.estadoValue = estado_asignar;
        this.estadoSelect = [this.estadoValue];
      }
    },
    async loadRelatores() {
      let idContrato = this.$store.getters.contratoStored;
      let idRelator = this.id;
      return await axios
        .get("/relator/" + idRelator + "/" + idContrato)
        .then(function (response) {
          return response.data;
        })
        .catch((error) => {
          if (error) {
            console.log(error.response.data);
            window.getApp.$emit("ERROR_EXCEPTION", error.response.data.message);
          }
          return [];
        });
    },
    back() {
      setTimeout(() => {
        this.$router.push({
          name: "ProcesoCapacitacion",
        });
      }, 1000);
    },
    save() {
      if (this.tipeView == "crear") {
        this.saveRelator();
      } else if (this.tipeView == "aprobacion") {
        this.apruebaCapacitacion();
      } else {
        this.editRelator();
      }
    },
    saveRelator() {
      this.loading = true;
      this.$v.$touch();
      let idContrato = this.$store.getters.contratoStored;
      let dv = this.obtenerDv(this.rut);
      let rut = this.obtenerSoloRut(this.rut);
      let v = this.validaRut(this.rut);

      if (v == false) {
        this.loading = false;
        window.getApp.$emit("ERROR_RUT");
        this.location.reload();
      } else if (
        this.nombre == "" ||
        this.apellido1 == "" ||
        this.apellido2 == "" ||
        this.fono == "" ||
        this.email == "" ||
        this.tipo_capValue == ""
      ) {
        this.loading = false;
        window.getApp.$emit("DATOS_INCOMPLETOS");
        this.location.reload();
      } else {
        this.body = {
          idContrato: idContrato,
          rut: rut,
          dv: dv,
          nombre: this.nombre,
          apellido1: this.apellido1,
          apellido2: this.apellido2,
          email: this.email,
          telefono: this.fono,
          tipoCapacitacion: this.tipo_capValue,
          filenameCv: this.filenameValue,
          documentoCv: this.base64Value,
          profesion: this.profesionValue,
        };
      }
      axios
        .post("/relator/create", this.body)
        .then((response) => {
          this.resp = response.data;
          window.getApp.$emit("APP_SAVE");
          this.loading = false;
          this.volver();
        })
        .catch((error) => {
          if (error == undefined || error == null) {
            console.log(error.response.data.defaultMessage);
          } else if (error.response.status == 400) {
            window.getApp.$emit("ERROR_EXCEPTION", error.response.data.message);
          } else if (error) {
            console.log(error.response.data);
            window.getApp.$emit("ERROR_EXCEPTION_BACK");
          }
          this.loading = false;
        });
    },
    editRelator() {
      this.loading = true;
      this.$v.$touch();
      let idContrato = this.$store.getters.contratoStored;
      let dv = this.obtenerDv(this.rut);
      let rut = this.obtenerSoloRut(this.rut);
      let v = this.validaRut(this.rut);
      let aa = "";
      if (this.aptoValue == "Si") {
        aa = 1;
      } else if (this.aptoValue == "No") {
        aa = 2;
      } else {
        aa = 0;
      }

      if (
        this.nombre == "" ||
        this.apellido1 == "" ||
        this.apellido2 == "" ||
        this.fono == "" ||
        this.email == "" ||
        this.tipo_capValue == ""
      ) {
        this.loading = false;
        window.getApp.$emit("DATOS_INCOMPLETOS");
        this.location.reload();
      } else if (this.user == "PROVEEDOR" || this.user == "ADMINISTRADOR") {
        this.body = {
          id: this.id,
          idContrato: idContrato,
          nombre: this.nombre,
          apellido1: this.apellido1,
          apellido2: this.apellido2,
          telefono: this.fono,
          tipoCapacitacion: this.tipo_capValue,
          filenameCv: this.filenameValue,
          documentoCv: this.base64Value,
          profesion: this.profesionValue,
        };
      } else if (this.user == "AGENCIA" || this.user == "ADMINISTRADOR") {
        this.body = {
          id: this.id,
          idContrato: idContrato,
          aptoAgencia: aa,
        };
      }
      axios
        .put("/relator/updateRelator", this.body)
        .then((response) => {
          this.resp = response.data;
          console.log(response.data);
          window.getApp.$emit("APP_SAVE");
          this.loading = false;
          this.volver();
        })
        .catch(function (error) {
          window.getApp.$emit("ERROR_EXCEPTION", error.response.data.message);
          this.loading = false;
          console.log(error);
        });
    },

    apruebaCapacitacion() {
      this.$v.$touch();
      let idContrato = this.$store.getters.contratoStored;
      let tipoDs;
      let tipoCon;
      let tipoCom;

      if (this.tipoCapDsValue == "Aprobado") {
        tipoDs = 1;
      } else if (this.tipoCapDsValue == "Reprobado") {
        tipoDs = 2;
      }
      if (this.tipoCapCompetenciasValue == "Aprobado") {
        tipoCom = 1;
      } else if (this.tipoCapCompetenciasValue == "Reprobado") {
        tipoCom = 2;
      }
      if (this.tipoCapConocimientosValue == "Aprobado") {
        tipoCon = 1;
      } else if (this.tipoCapConocimientosValue == "Reprobado") {
        tipoCon = 2;
      }

      this.body = {
        id: this.id,
        idContrato: idContrato,
        aptoDs: tipoDs,
        aptoConocimientos: tipoCon,
        aptoCompetencias: tipoCom,
      };
      axios
        .put("/relator/updateCapacitacion", this.body)
        .then((response) => {
          this.resp = response.data;
          console.log(response.data);
          window.getApp.$emit("APP_SAVE");
          this.volver();
        })
        .catch(function (error) {
          window.getApp.$emit("ERROR_EXCEPTION", error.response.data.message);
          console.log(error);
        });
    },
    downloadCv(id, filename) {
      let that = this;
      this.body = {
        fileName: filename,
        idContrato: this.contratoId,
        id: id,
      };

      axios
        .post("relator/downloadCV/", this.body, { responseType: "blob" })
        .then(function (response) {
          const urle = window.URL.createObjectURL(response.data);
          const link = document.createElement("a");
          link.href = urle;
          link.setAttribute("download", filename);
          document.body.appendChild(link);
          link.click();
          return response.data;
        })
        .catch(function (error) {
          console.log(error);
        });
    },

    async loadProfesiones() {
      this.profesionesData = await this.loadProfesionesData();
      let prof = [];
      this.profesionesData.forEach(function (e) {
        prof.push({
          nombre: e.descripcion,
          code: e.id,
        });
      });
      this.profesionSelect = prof;
    },

    async loadProfesionesData() {
      let idContrato = this.$store.getters.contratoStored;
      return await axios
        .get("/profesiones/" + idContrato)
        .then((response) => {
          return response.data;
        })
        .catch(function (error) {
          console.log(error);
        });
    },
    async loadTipoCapacitaciones() {
      this.capacitacionesData = await this.loadTipoCapacitacionesData();
      let cap = [];
      this.capacitacionesData.forEach(function (e) {
        cap.push({
          nombre: e.descripcion,
          code: e.id,
        });
      });
      this.tipo_capSelect = cap;
    },
    async loadTipoCapacitacionesData() {
      let idContrato = this.$store.getters.contratoStored;
      return await axios
        .get("/tiposCapacitaciones/" + idContrato)
        .then((response) => {
          return response.data;
        })
        .catch(function (error) {
          console.log(error);
        });
    },
    formatoFecha(f) {
      return f.replace(/^(\d{4})-(\d{2})-(\d{2})$/g, "$3-$2-$1");
    },
    formatoFechaView(f) {
      return f.replace(/^(\d{2})-(\d{2})-(\d{4})$/g, "$3-$2-$1");
    },
    volver() {
      this.$router.back();
    },
  },
};
</script>
